import { Box } from "@mui/material";
import type { ToolbarProps } from "react-big-calendar";
import type { Dayjs } from "dayjs";
import CustomCalendarToolbar from "@/components/CustomCalendarToolbar";
import { HouseVisitSlotsViewToggle } from "../HouseVisitSlotsViewToggle";
import { HouseVisitSlotsCalendarLegend } from "./HouseVisitSlotsCalendarLegend";

export type HouseVisitSlotsCalendarToolbarProps = ToolbarProps & {
  selectedDate: Dayjs;
  setSelectedDate: (d: Dayjs) => void;
};

export function HouseVisitSlotsCalendarToolbar({
  selectedDate,
  setSelectedDate,
  ...toolbarProps
}: HouseVisitSlotsCalendarToolbarProps) {
  return (
    <Box
      sx={{
        flexShrink: 0,
        borderBottom: 1,
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
    >
      <CustomCalendarToolbar
        {...toolbarProps}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        listToggleComponent={HouseVisitSlotsViewToggle}
      />
      <HouseVisitSlotsCalendarLegend />
    </Box>
  );
}
